import {
  getRecentlyViewedSpace,
  patchRecentlyViewedSpace,
} from '@core/api/spaces/getNupdateRecentlyViewedSpaces';
import { getSpaceById } from '@core/selectors/space';
import { FETCH_RECENTLY_VIEWED_SPACES } from '../actions';

const fetchRecentlyViewedSpaces = () => (dispatch, getState) => {
  const state = getState();
  dispatch({
    type: FETCH_RECENTLY_VIEWED_SPACES,
    status: 'started',
  });

  getRecentlyViewedSpace()
    .then(({ data: { spaces }, status }) => {
      if (status === 200) {
        const recentlyViewedSpaceInfo = spaces?.map(({ _id, ...rvs }) => {
          const assignedSpace = getSpaceById(state, _id); // Assigned Spaces
          return {
            spaceId: _id,
            name: rvs?.name,
            isStarred: assignedSpace?.isStarred,
            archived: rvs?.archived,
            avatar: rvs?.avatar,
            hasActivity: assignedSpace?.unread,
            isAssigned: assignedSpace?.objectId === _id,
            instructors: assignedSpace?.instructors,
            categories: assignedSpace?.categories,
          };
        }, []);

        dispatch({
          type: FETCH_RECENTLY_VIEWED_SPACES,
          payload: recentlyViewedSpaceInfo,
          status: 'success',
        });
      }
    })
    .catch(() => {
      dispatch({
        type: FETCH_RECENTLY_VIEWED_SPACES,
        payload: [],
        status: 'error',
      });
    });
};

const updateRecentlyViewedSpaces = (spaceId) => () => {
  patchRecentlyViewedSpace({ spaceId }).catch(() => {});
};

export { fetchRecentlyViewedSpaces, updateRecentlyViewedSpaces };
